export const DEFAULT_DESKTOP_HEIGHT = 60;
export const DEFAULT_MOBILE_HEIGHT = 42;
export const DEFAULT_FOCAL_X = 50;
export const DEFAULT_FOCAL_Y = 50;

export const clampNumber = (
  value: unknown,
  min: number,
  max: number,
  fallback: number,
) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(max, Math.max(min, parsed));
};

export const getParallaxMetrics = (data: Record<string, unknown>) => ({
  heightDesktop: clampNumber(
    data.height_desktop,
    35,
    90,
    DEFAULT_DESKTOP_HEIGHT,
  ),
  heightMobile: clampNumber(data.height_mobile, 25, 70, DEFAULT_MOBILE_HEIGHT),
  focalX: clampNumber(data.focal_x, 0, 100, DEFAULT_FOCAL_X),
  focalY: clampNumber(data.focal_y, 0, 100, DEFAULT_FOCAL_Y),
});
